import { IAvailabilities } from 'src/app/models';
import { IAvailabilitiesState, IPagination } from '../states';

export const initialAvailabilitiesState: IAvailabilitiesState = {
  value: [] as IAvailabilities[],
  isFetchingAvailabilities: true,
  pagination: {} as IPagination,
  searchValue: "",
  status: [],
  bookings: undefined,
  fromDate: undefined,
  toDate: undefined,
  startTime: undefined,
  endTime: undefined
};
